<template>
    <div class="company-management-container">
        <Card :padding="0" :bordered="false" :dis-hover="true" class="main-card">
            <div class="header-section">
                <div class="header-title">
                    <Icon type="ios-briefcase" size="24" color="#2d8cf0" />
                    <span class="title-text">公司管理</span>
                </div>
                <div class="header-actions">
                    <Button 
                        class="action-btn" 
                        type="primary" 
                        icon="md-add" 
                        @click="onCompanyCreate"
                    >
                        新增公司
                    </Button>
                    <Button 
                        class="action-btn" 
                        type="default" 
                        icon="ios-search" 
                        @click="toggleSearchCard"
                    >
                        {{ mainTable.searchCardShow ? '隐藏搜索' : '展开搜索' }}
                    </Button>
                </div>
            </div>


            <!-- 搜索区域 -->
            <transition name="slide-fade">
                <Card class="search-card" v-show="mainTable.searchCardShow">
                    <SearchCard :form="mainTable.searchForm"
                        :table-load-event="getCompanyList"
                        :table-search="mainTable.tableSearch"/>
                </Card>
            </transition>
            <!-- 表格区域 -->
            <div class="table-section">
                <PaginationTable
                    :columns="mainTable.columns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getCompanyList"
                ></PaginationTable>
            </div>
        </Card>
        
        <CompanyModal ref="companyModal" @refresh="refresh"/>
        
    </div>
</template>
<script>
import search from "@/libs/search";
import SearchCard from "@/components/searchCard/SearchCardNew.vue";
import { statusFormat } from "@/libs/baseModelFormat";
import PaginationTable from '@/components/pagination-table/pagination-table.vue';
import TableActionButtons from '@/components/table-action-buttons.vue';
import CompanyModal from './company-modal.vue';
import { getCompanyList, getCompanyInfo, deleteCompany } from '@/api/modules/system-management/company-management.js';
import { STATUS } from '@/libs/baseModelFormat.js';
export default {
    name: "CompanyList",
    components: {
        PaginationTable,
        TableActionButtons,
        CompanyModal,
        SearchCard
    },
    data() {
        return {
            innerSpin: false,
            mainTable: {
                searchCardShow: true,
                loading: false,
                columns: [
                    {
                        title: "行号",
                        type: "index",
                        width: 80,
                        align: "center"
                    },
                    /*{
                        title: "公司编码",
                        key: "code",
                        align: "center"
                    },*/
                    {
                        title: "公司名称",
                        key: "name",
                        align: "center"
                    },
                    {
                        title: "状态",
                        key: "status",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "span",
                                    {},
                                    STATUS(params.row.status)
                                )
                            ]);
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        render: (h, params) => {
                            const editButton = h(
                                "Button",
                                {
                                    props: { type: "text", size: "small" },
                                    on: {
                                        click: () => this.onCompanyUpdate(params.row)
                                    }
                                },
                                "编辑"
                            );

                            const deleteButton = h(
                                "Button",
                                {
                                    props: { type: "text", size: "small" },
                                    on: { click: () => this.onCompanyDel(params.row) }
                                },
                                "删除"
                            );

                            return h("div", [editButton, deleteButton]);
                        }
                    }
                ],
                data: [],
                tableSearch: search.getSearchParams(),
                searchForm: [
                    /*{
                        label: "公司编码",
                        type: "Input",
                        value: "",
                        name: "code",
                        sql: "like"
                    },*/
                    {
                        label: "公司名称",
                        type: "Input",
                        value: "",
                        name: "name",
                        sql: "like"
                    },
                    {
                        label: "状态",
                        type: "RadioGroup",
                        value: "",
                        name: "status",
                        sql: "eq",
                        options: [
                            { key: "启用", value: true },
                            { key: "禁用", value: false }
                        ]
                    }
                ]
            },
            
            stats: {
                totalCompanies: 0,
                activeCompanies: 0,
                inactiveCompanies: 0,
                newThisMonth: 0
            }
        };
    },
    computed: {
        
    },
    methods: {
        refresh(){
            this.getCompanyList();
        },
        toggleSearchCard() {
            this.mainTable.searchCardShow = !this.mainTable.searchCardShow;
        },
        getCompanyList() {
            this.mainTable.loading = true;
            
            getCompanyList(this.mainTable.tableSearch)
                .then(response => {
                    this.mainTable.data = response.data.records;
                    search.globalSetFilterRecordCount(
                        this.mainTable.tableSearch,
                        response.data.filterRecordCount
                    );
                })
                .catch(error => {
                    this.$Message.error('获取公司列表失败');
                    console.error('获取公司列表失败:', error);
                })
                .finally(() => {
                    this.mainTable.loading = false;
                    this.updateStats();
                });
        },
        handleSearch() {
            this.getCompanyList();
        },
        handleReset() {
            this.resetSearchForm();
            this.handleSearch();
        },
        resetSearchForm() {
            this.mainTable.searchForm = {
                name: '',
                code: '',
                contact: '',
                status: ''
            };
        },
        onCompanyCreate() {
            this.$refs.companyModal.showModal();
        },
        onCompanyEdit(row) {
            
            this.$refs.companyModal.showModal(row);
        },
        onCompanyDelete(row) {
            this.$Modal.confirm({
                title: '删除确认',
                content: `确定要删除公司"${row.name}"吗？此操作不可恢复！`,
                loading: true,
                onOk: () => {
                    deleteCompany({ id: row.id })
                        .then(() => {
                            this.$Modal.remove();
                            this.$Message.success('删除成功');
                            this.getCompanyList();
                        })
                        .catch(error => {
                            this.$Modal.remove();
                            this.$Message.error('删除失败');
                            console.error('删除公司失败:', error);
                        });
                }
            });
        },
        onViewDetail(row) {
            this.$Message.info(`查看公司 "${row.name}" 的详细信息`);
        },
        onCompanyUpdate(row) {
            console.log("row", row);
            this.$refs.companyModal.showModal(row);
        },
        onCompanyDel(row) {
            this.$Modal.confirm({
                title: '删除确认',
                content: `确定要删除公司"${row.name}"吗？此操作不可恢复！`,
                loading: true,
                onOk: () => {
                    deleteCompany({ id: row.id })
                        .then(() => {
                            this.$Modal.remove();
                            this.$Message.success('删除成功');
                            this.getCompanyList();
                        })
                        .catch(error => {
                            this.$Modal.remove();
                            this.$Message.error('删除失败');
                            console.error('删除公司失败:', error);
                        });
                }
            });
        },
        exportData(){

        }
        
    },
    mounted() {
        this.getCompanyList();
    }
};
</script>

<style lang="less" scoped>
.company-management-container {
    padding: 20px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;

    .main-card {
        border-radius: 12px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
    }

    .header-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 24px;
        border-bottom: 1px solid rgba(232, 234, 236, 0.5);
        background: linear-gradient(135deg, rgba(45, 140, 240, 0.05) 0%, rgba(25, 190, 107, 0.05) 100%);

        .header-title {
            display: flex;
            align-items: center;
            transition: transform 0.3s ease;

            &:hover {
                transform: translateY(-1px);
            }

            .title-text {
                margin-left: 12px;
                font-size: 20px;
                font-weight: 700;
                color: #262626;
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
            }
        }

        .header-actions {
            display: flex;
            gap: 12px;

            .action-btn {
                .button-base();
            }
        }
    }

    .search-card {
        .card-base();
        margin: 20px;

        .search-form {
            padding: 20px 0;

            .search-actions {
                display: flex;
                justify-content: flex-end;
                gap: 12px;
                margin-top: 16px;

                button {
                    .button-base();
                    transform: translateY(-1px);
                }
            }
        }
    }

    // 通用样式混入
    .button-base() {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        padding: 8px 16px;
        font-weight: 500;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
    }

    .card-base() {
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        border: 1px solid rgba(255, 255, 255, 0.3);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);
        }
    }

    .stats-section {
        padding: 20px;

        .stat-card {
            .card-base();
            height: 120px;
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            overflow: hidden;
            position: relative;

            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 3px;
                background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
            }

            &:hover {
                transform: translateY(-5px) scale(1.02);
                box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
            }

            .stat-content {
                display: flex;
                align-items: center;
                height: 100%;
                padding: 0 20px;
                position: relative;
                z-index: 2;

                .stat-icon {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 20px;
                    transition: all 0.3s ease;

                    &.bg-blue {
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
                    }

                    &.bg-green {
                        background: linear-gradient(135deg, #56ab2f 0%, #a8e6cf 100%);
                        box-shadow: 0 4px 15px rgba(86, 171, 47, 0.4);
                    }

                    &.bg-orange {
                        background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
                        box-shadow: 0 4px 15px rgba(240, 147, 251, 0.4);
                    }

                    &.bg-red {
                        background: linear-gradient(135deg, #ff6b6b 0%, #ffa726 100%);
                        box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
                    }

                    &:hover {
                        transform: scale(1.1) rotate(5deg);
                    }
                }

                .stat-info {
                    .stat-title {
                        font-size: 14px;
                        color: #8c93a0;
                        margin-bottom: 8px;
                        font-weight: 500;
                        letter-spacing: 0.5px;
                    }

                    .stat-value {
                        font-size: 28px;
                        font-weight: 700;
                        color: #262626;
                        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    }
                }

                .stat-trend {
                    margin-left: auto;
                    font-size: 12px;
                    color: #19be6b;

                    &.negative {
                        color: #ed4014;
                    }
                }
            }
        }
    }

    .table-section {
        padding: 0 20px 20px;

        .data-table {
            margin-top: 20px;
            .card-base();
            border-radius: 12px;
            overflow: hidden;
            transition: box-shadow 0.3s ease;

            .ivu-table-header {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                
                th {
                    background: none;
                    color: #fff;
                    font-weight: 600;
                    font-size: 14px;
                    border-bottom: none;
                    
                    .ivu-table-cell {
                        padding: 12px 8px;
                    }
                }
            }

            .ivu-table-body {
                tr {
                    transition: all 0.3s ease;

                    &:hover {
                        background-color: rgba(102, 126, 234, 0.08) !important;
                        transform: scale(1.01);
                    }

                    .ivu-table-cell {
                        padding: 14px 8px;
                        font-size: 13px;
                        color: #595959;
                    }
                }
            }

            .action-buttons {
                display: flex;
                gap: 8px;
                justify-content: center;

                button {
                    .button-base();
                    border-radius: 6px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }
            }
        }

        .table-pagination {
            margin-top: 20px;
            text-align: center;
            padding: 16px;
            .card-base();

            .ivu-page-item,
            .ivu-page-next,
            .ivu-page-prev {
                border-radius: 8px;
                transition: all 0.3s ease;

                &:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
                }
            }

            .ivu-page-item-active {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                border-color: #667eea;
            }
        }
    }

    // 动画效果
    .slide-fade-enter-active {
        transition: all 0.3s ease;
    }

    .slide-fade-leave-active {
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;
    }

    // 响应式设计
    @media (max-width: 768px) {
        .header-section {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;

            .header-actions {
                width: 100%;
                justify-content: space-between;
            }
        }

        .stats-section {
            .ivu-col {
                margin-bottom: 16px;
            }
        }

        .search-card {
            .ivu-col {
                margin-bottom: 16px;
            }
        }
    }
}
</style>
